<div class="divHome" style="padding-bottom: 0px !important">
  <div class="header-container">
    <h1>Reporte de Personal de Campo</h1>
    <div class="location-container" *ngIf="location">
      <i-tabler name="map-pin"></i-tabler>
      <h1>{{ getLocation(location) }}</h1>
    </div>
  </div>

  <div *ngIf="loading" class="spinner">
    <mat-progress-spinner mode="indeterminate"></mat-progress-spinner>
  </div>

  <div class="divButtons" *ngIf="!loading" style="margin-bottom: 1rem">
    <!-- FILTRO FECHA -->
    <mat-form-field class="buttonFilterFecha">
      <mat-label>FECHA</mat-label>

      <mat-datepicker-toggle
        matSuffix
        [for]="rangePicker"
      ></mat-datepicker-toggle>

      <mat-date-range-input [rangePicker]="rangePicker">
        <input matStartDate placeholder="Inicio" [(ngModel)]="startDate" />
        <input matEndDate placeholder="Fin" [(ngModel)]="endDate" />
      </mat-date-range-input>

      <mat-date-range-picker #rangePicker>
        <mat-date-range-picker-actions>
          <button mat-button matDateRangePickerCancel>Cancel</button>
          <button
            style="background-color: rgb(184, 69, 18)"
            mat-raised-button
            color="primary"
            (click)="onApplyRangeSelected()"
            matDateRangePickerApply
          >
            Filtrar
          </button>

          <button
            mat-button
            matDateRangePickerCancel
            (click)="cleanDateSelected()"
          >
            Limpiar
          </button>
        </mat-date-range-picker-actions>
      </mat-date-range-picker>
    </mat-form-field>

    <!-- FILTRO PROVEEDOR -->
    <mat-form-field appearance="fill" class="buttonFilter">
      <mat-label>PROVEEDOR</mat-label>
      <mat-select
        [(value)]="selectedProveedor"
        (selectionChange)="applyFilterSelect()"
        (openedChange)="onDropdownOpened($event, 'proveedor')"
        panelClass="custom-filter-select-panel"
        #selectProveedor
      >
        <mat-select-trigger *ngIf="selectedProveedor">
          {{ selectedProveedor }}
        </mat-select-trigger>

        <div
          class="select-search-header"
          (click)="$event.stopPropagation()"
          (keydown)="onSearchKeydown($event, 'proveedor', selectProveedor)"
        >
          <div class="select-search-box">
            <i-tabler name="search" class="search-box-icon"></i-tabler>
            <input
              id="select-search-proveedor"
              type="text"
              class="select-search-input"
              placeholder="Buscar proveedor..."
              [ngModel]="searchQueries.proveedor"
              (ngModelChange)="onSearchFilter('proveedor', $event)"
              (click)="$event.stopPropagation()"
              autocomplete="off"
            />
            <button
              *ngIf="searchQueries.proveedor"
              type="button"
              class="select-search-clear-btn"
              (click)="clearSearchQuery('proveedor', $event)"
              title="Limpiar búsqueda"
            >
              <i-tabler name="x"></i-tabler>
            </button>
          </div>
        </div>

        <mat-option [value]="null" class="option-no-select">
          No seleccionar
        </mat-option>
        <mat-option
          *ngFor="let proveedor of filteredOptions.proveedor"
          [value]="proveedor"
        >
          {{ proveedor }}
        </mat-option>
        <div
          *ngIf="filteredOptions.proveedor.length === 0"
          class="select-empty-message"
        >
          No se encontraron coincidencias para "{{ searchQueries.proveedor }}"
        </div>
      </mat-select>

      <button
        *ngIf="selectedProveedor"
        mat-icon-button
        matSuffix
        type="button"
        class="filter-field-clear-btn"
        (click)="clearSelectedFilter('proveedor', $event)"
        title="Limpiar filtro de proveedor"
      >
        <i-tabler name="x"></i-tabler>
      </button>
    </mat-form-field>

    <!-- FILTRO CATEGORÍA -->
    <mat-form-field appearance="fill" class="buttonFilter">
      <mat-label>CATEGORÍA</mat-label>
      <mat-select
        [(value)]="selectedCategoria"
        (selectionChange)="applyFilterSelect()"
        (openedChange)="onDropdownOpened($event, 'categoria')"
        panelClass="custom-filter-select-panel"
        #selectCategoria
      >
        <mat-select-trigger *ngIf="selectedCategoria">
          {{ selectedCategoria }}
        </mat-select-trigger>

        <div
          class="select-search-header"
          (click)="$event.stopPropagation()"
          (keydown)="onSearchKeydown($event, 'categoria', selectCategoria)"
        >
          <div class="select-search-box">
            <i-tabler name="search" class="search-box-icon"></i-tabler>
            <input
              id="select-search-categoria"
              type="text"
              class="select-search-input"
              placeholder="Buscar categoría..."
              [ngModel]="searchQueries.categoria"
              (ngModelChange)="onSearchFilter('categoria', $event)"
              (click)="$event.stopPropagation()"
              autocomplete="off"
            />
            <button
              *ngIf="searchQueries.categoria"
              type="button"
              class="select-search-clear-btn"
              (click)="clearSearchQuery('categoria', $event)"
              title="Limpiar búsqueda"
            >
              <i-tabler name="x"></i-tabler>
            </button>
          </div>
        </div>

        <mat-option [value]="null" class="option-no-select">
          No seleccionar
        </mat-option>
        <mat-option
          *ngFor="let categoria of filteredOptions.categoria"
          [value]="categoria"
        >
          {{ categoria }}
        </mat-option>
        <div
          *ngIf="filteredOptions.categoria.length === 0"
          class="select-empty-message"
        >
          No se encontraron coincidencias para "{{ searchQueries.categoria }}"
        </div>
      </mat-select>

      <button
        *ngIf="selectedCategoria"
        mat-icon-button
        matSuffix
        type="button"
        class="filter-field-clear-btn"
        (click)="clearSelectedFilter('categoria', $event)"
        title="Limpiar filtro de categoría"
      >
        <i-tabler name="x"></i-tabler>
      </button>
    </mat-form-field>

    <!-- FILTRO COMUNIDAD -->
    <mat-form-field appearance="fill" class="buttonFilter">
      <mat-label>COMUNIDAD</mat-label>
      <mat-select
        [(value)]="selectedComunidad"
        (selectionChange)="applyFilterSelect()"
        (openedChange)="onDropdownOpened($event, 'comunidad')"
        panelClass="custom-filter-select-panel"
        #selectComunidad
      >
        <mat-select-trigger *ngIf="selectedComunidad">
          {{ selectedComunidad }}
        </mat-select-trigger>

        <div
          class="select-search-header"
          (click)="$event.stopPropagation()"
          (keydown)="onSearchKeydown($event, 'comunidad', selectComunidad)"
        >
          <div class="select-search-box">
            <i-tabler name="search" class="search-box-icon"></i-tabler>
            <input
              id="select-search-comunidad"
              type="text"
              class="select-search-input"
              placeholder="Buscar comunidad..."
              [ngModel]="searchQueries.comunidad"
              (ngModelChange)="onSearchFilter('comunidad', $event)"
              (click)="$event.stopPropagation()"
              autocomplete="off"
            />
            <button
              *ngIf="searchQueries.comunidad"
              type="button"
              class="select-search-clear-btn"
              (click)="clearSearchQuery('comunidad', $event)"
              title="Limpiar búsqueda"
            >
              <i-tabler name="x"></i-tabler>
            </button>
          </div>
        </div>

        <mat-option [value]="null" class="option-no-select">
          No seleccionar
        </mat-option>
        <mat-option
          *ngFor="let comunidad of filteredOptions.comunidad"
          [value]="comunidad"
        >
          {{ comunidad }}
        </mat-option>
        <div
          *ngIf="filteredOptions.comunidad.length === 0"
          class="select-empty-message"
        >
          No se encontraron coincidencias para "{{ searchQueries.comunidad }}"
        </div>
      </mat-select>

      <button
        *ngIf="selectedComunidad"
        mat-icon-button
        matSuffix
        type="button"
        class="filter-field-clear-btn"
        (click)="clearSelectedFilter('comunidad', $event)"
        title="Limpiar filtro de comunidad"
      >
        <i-tabler name="x"></i-tabler>
      </button>
    </mat-form-field>

    <!-- FILTRO FILE -->
    <mat-form-field appearance="fill" class="buttonFilter">
      <mat-label>FILE</mat-label>
      <mat-select
        [(value)]="selectedFile"
        (selectionChange)="applyFilterSelect()"
        (openedChange)="onDropdownOpened($event, 'file')"
        panelClass="custom-filter-select-panel"
        #selectFile
      >
        <mat-select-trigger *ngIf="selectedFile">
          {{ selectedFile }}
        </mat-select-trigger>

        <div
          class="select-search-header"
          (click)="$event.stopPropagation()"
          (keydown)="onSearchKeydown($event, 'file', selectFile)"
        >
          <div class="select-search-box">
            <i-tabler name="search" class="search-box-icon"></i-tabler>
            <input
              id="select-search-file"
              type="text"
              class="select-search-input"
              placeholder="Buscar file..."
              [ngModel]="searchQueries.file"
              (ngModelChange)="onSearchFilter('file', $event)"
              (click)="$event.stopPropagation()"
              autocomplete="off"
            />
            <button
              *ngIf="searchQueries.file"
              type="button"
              class="select-search-clear-btn"
              (click)="clearSearchQuery('file', $event)"
              title="Limpiar búsqueda"
            >
              <i-tabler name="x"></i-tabler>
            </button>
          </div>
        </div>

        <mat-option [value]="null" class="option-no-select">
          No seleccionar
        </mat-option>
        <mat-option *ngFor="let file of filteredOptions.file" [value]="file">
          {{ file }}
        </mat-option>
        <div
          *ngIf="filteredOptions.file.length === 0"
          class="select-empty-message"
        >
          No se encontraron coincidencias para "{{ searchQueries.file }}"
        </div>
      </mat-select>

      <button
        *ngIf="selectedFile"
        mat-icon-button
        matSuffix
        type="button"
        class="filter-field-clear-btn"
        (click)="clearSelectedFilter('file', $event)"
        title="Limpiar filtro de file"
      >
        <i-tabler name="x"></i-tabler>
      </button>
    </mat-form-field>

    <!-- FILTRO RUTA -->
    <mat-form-field appearance="fill" class="buttonFilter">
      <mat-label>RUTA</mat-label>
      <mat-select
        [(value)]="selectedRuta"
        (selectionChange)="applyFilterSelect()"
        (openedChange)="onDropdownOpened($event, 'ruta')"
        panelClass="custom-filter-select-panel"
        #selectRuta
      >
        <mat-select-trigger *ngIf="selectedRuta">
          {{ selectedRuta }}
        </mat-select-trigger>

        <div
          class="select-search-header"
          (click)="$event.stopPropagation()"
          (keydown)="onSearchKeydown($event, 'ruta', selectRuta)"
        >
          <div class="select-search-box">
            <i-tabler name="search" class="search-box-icon"></i-tabler>
            <input
              id="select-search-ruta"
              type="text"
              class="select-search-input"
              placeholder="Buscar ruta..."
              [ngModel]="searchQueries.ruta"
              (ngModelChange)="onSearchFilter('ruta', $event)"
              (click)="$event.stopPropagation()"
              autocomplete="off"
            />
            <button
              *ngIf="searchQueries.ruta"
              type="button"
              class="select-search-clear-btn"
              (click)="clearSearchQuery('ruta', $event)"
              title="Limpiar búsqueda"
            >
              <i-tabler name="x"></i-tabler>
            </button>
          </div>
        </div>

        <mat-option [value]="null" class="option-no-select">
          No seleccionar
        </mat-option>
        <mat-option *ngFor="let ruta of filteredOptions.ruta" [value]="ruta">
          {{ ruta }}
        </mat-option>
        <div
          *ngIf="filteredOptions.ruta.length === 0"
          class="select-empty-message"
        >
          No se encontraron coincidencias para "{{ searchQueries.ruta }}"
        </div>
      </mat-select>

      <button
        *ngIf="selectedRuta"
        mat-icon-button
        matSuffix
        type="button"
        class="filter-field-clear-btn"
        (click)="clearSelectedFilter('ruta', $event)"
        title="Limpiar filtro de ruta"
      >
        <i-tabler name="x"></i-tabler>
      </button>
    </mat-form-field>

    <!-- BOTÓN LIMPIAR TODOS LOS FILTROS -->
    <button
      *ngIf="hasActiveFilters"
      mat-stroked-button
      type="button"
      class="button-clear-all"
      (click)="clearAllFilters()"
      title="Restablecer todos los filtros"
    >
      <i-tabler name="filter-off"></i-tabler>
      <span>Limpiar filtros</span>
    </button>
  </div>

  <div *ngIf="dataSource">
    <div class="overflow" *ngIf="!loading && dataSource.data.length > 0">
      <mat-table [dataSource]="dataSource" class="mat-elevation-z8">
        <ng-container matColumnDef="fecha-inicio">
          <mat-header-cell *matHeaderCellDef>FECHA INICIO</mat-header-cell>
          <mat-cell *matCellDef="let element">{{
            element?.fechasOcupadas?.fechaInicio || "-"
          }}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="file">
          <mat-header-cell *matHeaderCellDef>FILE</mat-header-cell>
          <mat-cell *matCellDef="let element">{{
            element?.fechasOcupadas?.fileNumber || "-"
          }}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="proveedor">
          <mat-header-cell *matHeaderCellDef>Proveedor</mat-header-cell>
          <mat-cell *matCellDef="let element">{{
            element?.proveedor?.nombre || "-"
          }}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="categoria">
          <mat-header-cell *matHeaderCellDef>Categoría</mat-header-cell>
          <mat-cell *matCellDef="let element">{{
            element?.fechasOcupadas?.categoriaServicio || "-"
          }}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="correo">
          <mat-header-cell *matHeaderCellDef>CORREO</mat-header-cell>
          <mat-cell *matCellDef="let element">{{
            element?.contactos?.contactoCorreo ||
              element?.proveedor?.contactos?.contactoCorreo ||
              "-"
          }}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="telefono">
          <mat-header-cell *matHeaderCellDef>TELÉFONO</mat-header-cell>
          <mat-cell *matCellDef="let element">{{
            element?.contactos?.contactoCelular ||
              element?.proveedor?.contactos?.contactoCelular ||
              "-"
          }}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="comunidad">
          <mat-header-cell *matHeaderCellDef>Comunidad</mat-header-cell>
          <mat-cell *matCellDef="let element">
            {{ element?.proveedor?.personalCampoInfo?.comunidad || "-" }}
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="ruta">
          <mat-header-cell *matHeaderCellDef>RUTA</mat-header-cell>
          <mat-cell *matCellDef="let element">{{
            element?.fechasOcupadas?.productName || "-"
          }}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="fecha-liberacion">
          <mat-header-cell *matHeaderCellDef>FECHA LIBERACIÓN</mat-header-cell>
          <mat-cell *matCellDef="let element">{{
            element?.fechasOcupadas?.fechaFin || "-"
          }}</mat-cell>
        </ng-container>

        <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
        <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
      </mat-table>
    </div>

    <!-- ESTADO VACÍO CUANDO NO HAY COINCIDENCIAS -->
    <div *ngIf="!loading && dataSource.data.length === 0" class="no-data-card">
      <i-tabler name="alert-circle" class="no-data-icon"></i-tabler>
      <p class="no-data-title">No se encontraron registros</p>
      <p class="no-data-subtitle">
        No hay datos que coincidan con los filtros seleccionados.
      </p>
    </div>

    <div [hidden]="loading || dataSource.data.length === 0">
      <mat-paginator [pageSizeOptions]="[5, 10, 20]" showFirstLastButtons>
      </mat-paginator>
    </div>
  </div>
</div>
